import * as React from "react";
import "./LocationMarker.css";
import { Typography, Button } from "@mui/material";
import { Place } from "../../../types";
import { Marker, Popup, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useWebServer } from "../../../providers";
import { MarkerIcon } from "./MarkerIcon";
import L, { LatLng } from "leaflet";

interface Props {
  handleClick: (address?: Place) => void;
}

export const LocationMarker: React.FC<Props> = ({ handleClick }) => {
  const [position, setPosition] = React.useState<LatLng>();
  const markerRef = React.useRef<L.Marker>(null);
  const { getAddressFromGPSLocation } = useWebServer();
  const [place, setPlace] = React.useState<Place>({
    display_name: "",
    lat: "",
    lon: "",
  });

  useMapEvents({
    click(e) {
      setPosition(e.latlng);
      getAddressFromGPSLocation(
        e.latlng.lat.toString(),
        e.latlng.lng.toString()
      ).then((res?: Place) => {
        if (res) {
          setPlace(res);
        }
        const marker = markerRef.current;
        if (marker) {
          marker.openPopup();
        }
      });
    },
  });

  const handleMarkerClick = () => {
    handleClick(place);
  };

  return position ? (
    <Marker position={position} icon={MarkerIcon} ref={markerRef}>
      <Popup keepInView={true}>
        <Typography>
          <b>GPS: </b>
          {`${"\xa0".repeat(7)}${Number.parseFloat(place.lat)?.toFixed(
            5
          )}, ${Number.parseFloat(place.lon)?.toFixed(5)}`}
          <br></br>
          <b>Address: </b>
          {`${place.display_name}`}
        </Typography>
        <div className="btn-select-marker-at-address">
          <Button variant="contained" onClick={handleMarkerClick}>
            Use this address
          </Button>
        </div>
      </Popup>
    </Marker>
  ) : (
    <></>
  );
};
